import React, { FC } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';

import useCommonStyles from 'styles/common';
import CenterImage from 'components/common/CenterImage';

import awardsTitleImg from 'assets/invoice/awards-title.svg';
import flightCardRedTitleImg from 'assets/invoice/flight-title-kyushu.svg';
import flightCardRedImg from 'assets/invoice/kyushu-img.png';
import flightCardBrownTitleImg from 'assets/invoice/flight-title-hokkaido.svg';
import flightCardBrownImg from 'assets/invoice/hokkaido-img.png';
import airplaneBrownImg from 'assets/invoice/airplane-b.svg';
import airplaneRedImg from 'assets/invoice/airplane-r.svg';
import { Cauli, Milk03 } from 'components/home/stamps';

import award01 from 'assets/invoice/awards/1.png';
import award02 from 'assets/invoice/awards/2.png';
import award03 from 'assets/invoice/awards/3.png';
import award04 from 'assets/invoice/awards/4.png';
import award05 from 'assets/invoice/awards/5.png';
import award06 from 'assets/invoice/awards/6.png';



const useStyles = makeStyles((theme) => ({
	awards: {
		padding: 24,
        paddingBottom: 0,
        color: 'var(--color-tertiary)',
        position: 'relative',
        [theme.breakpoints.down('xs')]: {
            padding: '4px 24px 0 24px'
        }
	},
	awardsTitle: {
		marginBottom: 36,
        [theme.breakpoints.down('xs')]: {
            width: 320
        }
	},
    awardsSubtitle: {
        marginBottom: 30,
        [theme.breakpoints.down('xs')]: {
            padding: '0 14px'
        }
    },
    cardsContainer: {
		maxWidth: 880,
		display: 'flex',
		flexWrap: 'wrap',
		gap: 16,
        [theme.breakpoints.down('xs')]: {
            gap: 8
        }
    },
    card: { // cardsContainer 內部共用的
        position: 'relative',
		borderRadius: 16,
        textAlign: 'center',
    },
    flightCard: {
		flex: '1 1 150px',
        height: '100%',
        maxHeight: 520,
        aspectRatio: '433 / 528',
        padding: 16,
        justifyContent: 'end',
        [theme.breakpoints.down('xs')]: {
		    flex: '1 1 300px',
            padding: '13px 8px 10px 8px',
            maxHeight: 328,
        }
    },
    flightCardRedTitle: {
        marginTop: 16,
        marginBottom: 24,
        [theme.breakpoints.down('xs')]: {
            marginTop: 8,
            maxWidth: 240,
            height: 32
        }
    },
    flightCardBrownTitle: {
        marginTop: 16,
        marginBottom: 24,
        [theme.breakpoints.down('xs')]: {
            marginTop: 8,
            maxWidth: 216,
            height: 32
        }
    },
    flightCardImage: {
        overflow: 'hidden',
        borderRadius: 16
    },

    flightCardRed: {
        backgroundColor: 'var(--color-primary)',
        [theme.breakpoints.down('xs')]: {
            marginBottom: 14
        }
    },
    flightCardBrown: {
        backgroundColor: 'var(--color-tertiary)',
    },



    airplaneRed: {
        position: 'absolute',
        top: -36,
        right: -67,
        [theme.breakpoints.down('xs')]: {
            height: 40,
            top: -14,
            right: -15,
        }
    },
    airplaneBrown: {
        position: 'absolute',
        top: -36,
        left: -70,
        [theme.breakpoints.down('xs')]: {
            height: 40,
            top: -15,
            left: -12,
        }
    },
    awardContainer: {
        '& > div:nth-of-type(1) > div img': {
            width: 200
        },
        [theme.breakpoints.down('xs')]: {
            '& > div:nth-of-type(1) > div img': {
                maxWidth: 108
            },
            '& > div:nth-of-type(2), > div:nth-of-type(3), > div:nth-of-type(4), > div:nth-of-type(6)': {
                '& > div img': {
                    maxWidth: 80
                }
            },
            '& > div:nth-of-type(5) > div img': {
                maxWidth: 140
            },
        }

    },
    awardContent: {
        flex: '0 1 calc((100% - 40px) / 3)',
        [theme.breakpoints.down('xs')]: {
            flex: '0 1 calc((100% - 8px) / 2)'
        }
    },
    awardCard: {
        padding: 17,
		backgroundColor: 'var(--color-white)',
		aspectRatio: '1/1',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
		borderRadius: 16,
        boxSizing: 'border-box',
        justifyContent: 'space-between',

        '& span': {
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: 75, // 87-12
            height: 57, // 69 -12
            padding: 6,
            backgroundColor: 'var(--color-tertiary)',
            color: 'var(--color-white)',
            fontFamily: 'MSung HK Medium, MSung HK, Noto Serif TC, sans-serif',
            fontSize: 24,
            lineHeight: 1.33,
            clipPath: 'polygon(100% 0, 100% 100%, 0% 100%)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'end',
            [theme.breakpoints.down('xs')]: {
                width: 38, // 46 - 8
                height: 24, // 36  - 12
                padding: '6px 4px',
                fontSize: 12
            }
        }
    },
    awardDesc: {
        paddingTop: 16,
        paddingBottom: 20,
        [theme.breakpoints.down('xs')]: {
            paddingBottom: 16,

        }
    },
}));


const InvoiceAwardSection: FC = () => {
    const classes = useStyles();
	const common = useCommonStyles();

    return (<div className={ cx(classes.awards, common.columnCenter, common.fullWidth) }>
        <Milk03 style={{ bottom: 60, left: 'calc(50vw - 665px)'}} />
        <Cauli style={{ bottom: 28, right: 'calc(50vw - 684px)', transform: 'rotate(40deg)'}} />
        
		<CenterImage src={awardsTitleImg} alt='awards' className={ classes.awardsTitle } maxWidth={384}/>
		<Typography
			variant="body1" 
			style={{ whiteSpace: 'pre-line' }}
            className={ classes.awardsSubtitle }
		>
			{`活動最大獎項規劃日本來回機票
				由最終紅白洋食對決投票結果決定來回機票的地點`}
		</Typography>

        <div className={ cx(common.fullWidth, classes.cardsContainer) } style={{ marginBottom: 30 }}>
            <div className={ cx(classes.card, classes.flightCard, classes.flightCardRed, common.columnCenter) }>
                <Typography
                    variant="body1" 
                    style={{ whiteSpace: 'pre-line', color: 'var(--color-white)' }}
                >
                    {`紅色獲勝
                    送出
                    日本蕃茄產地`}
                </Typography>
		        <CenterImage 
                    className={ cx(classes.flightCardRedTitle) } maxWidth={360}
                    src={flightCardRedTitleImg} alt='kyushu-flight'
                />
		        <CenterImage src={flightCardRedImg} className={classes.flightCardImage} alt='kyushu-photo'/>
                <img src={airplaneBrownImg} alt='airplane-brown' className={ classes.airplaneBrown }/>
            </div>

            <div className={ cx(classes.card, classes.flightCard, classes.flightCardBrown, common.columnCenter) }>
                <Typography
                    variant="body1" 
                    style={{ whiteSpace: 'pre-line', color: 'var(--color-white)' }}
                >
                    {`白色獲勝
                    送出
                    日本牛奶產地`}
                </Typography>
                <CenterImage 
                    className={ cx(classes.flightCardBrownTitle) } maxWidth={324}   
                    src={flightCardBrownTitleImg} alt='hokkaido-flight'
                />
		        <CenterImage src={flightCardBrownImg} className={classes.flightCardImage} alt='hokkaido-photo'/>
                <img src={airplaneRedImg} alt='airplane-red' className={ classes.airplaneRed }/>
            </div>

        </div>

        <div className={ cx(common.fullWidth, classes.cardsContainer, classes.awardContainer) } style={{ marginBottom: 16 }}>
            <div className={ cx(classes.card, common.columnCenter, classes.awardContent) }>  
                <div className={cx(classes.awardCard, common.columnCenter)}>
                    <Typography variant="body1">{'登錄就抽'}</Typography>
                    <CenterImage src={award01} />
                    <Typography variant="body2">{'價值 $30,000'}</Typography>
                    <span className={ common.center }>1名</span>
                </div>
                <div className={classes.awardDesc}>
                    <Typography variant="body1" >{`日本來回機票一張`}</Typography>
                </div>
            </div>
        
            <div className={ cx(classes.card, common.columnCenter, classes.awardContent) }>
                <div className={cx(classes.awardCard, common.columnCenter)}>
                    <Typography variant="body1">{'登錄就抽'}</Typography>
                    <CenterImage src={award02} />
                    <Typography variant="body2">{'價值 $19,990'}</Typography>
                    <span>1名</span>
                </div>
                <div className={classes.awardDesc}>
                <Typography variant="body1" >{`【ZOJIRUSHI 象印】`}</Typography>
                <Typography variant="body1" >{`2024年新機型`}</Typography>
                <Typography variant="body1" >{`空中微波烘烤微波爐23L ES-JAF23`}</Typography>
                {/* <Typography variant="body1" >{`ES-JAF23`}</Typography> */}
                </div>
            </div>

            <div className={ cx(classes.card, common.columnCenter, classes.awardContent) }>
                <div className={cx(classes.awardCard, common.columnCenter)}>
                    <Typography variant="body1">{'登錄就抽'}</Typography>
                    <CenterImage src={award03} />
                    <Typography variant="body2">{'價值 $15,990'}</Typography>
                    <span>1名</span>
                </div>
                <div className={classes.awardDesc}>
                <Typography variant="body1" >{`【ZOJIRUSHI 象印】`}</Typography>
                <Typography variant="body1" >{`日本製 STAN. 美型 `}</Typography>
                <Typography variant="body1" >{`IH 電子鍋6人份`}</Typography>
                <Typography variant="body1" >{`NW-SAF10`}</Typography>
                </div>
            </div>
            <div className={ cx(classes.card, common.columnCenter, classes.awardContent) }>  
                <div className={cx(classes.awardCard, common.columnCenter)}>
                    <Typography variant="body1">{'登錄就抽'}</Typography>
                    <CenterImage src={award04} />
                    <Typography variant="body2">{'價值 $7,980'}</Typography>
                    <span className={ common.center }>1名</span>
                </div>
                <div className={classes.awardDesc}>
                <Typography variant="body1" >{`【FELLOW】`}</Typography>
                <Typography variant="body1" >{`Opus 錐刀磨豆機`}</Typography>
                </div>
            </div>
            <div className={ cx(classes.card, common.columnCenter, classes.awardContent) }>  
                <div className={cx(classes.awardCard, common.columnCenter)}>
                    <Typography variant="body1">{'登錄就抽'}</Typography>
                    <CenterImage src={award05} />
                    <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                        {`兩項商品合計
                        總價值$3,350`}</Typography>
                    <span className={ common.center }>1名</span>
                </div>
                <div className={classes.awardDesc}>
                <Typography variant="body1" >{`【THERMOS】`}</Typography>
                <Typography variant="body1" >{`厚鑄耐摩不沾鍋_KFM_26cm & Masa `}</Typography>
                <Typography variant="body1" >{`親筆簽名最新食譜書`}</Typography>
                </div>
            </div>
            <div className={ cx(classes.card, common.columnCenter, classes.awardContent) }>  
                <div className={cx(classes.awardCard, common.columnCenter)}>
                    <Typography variant="body1">{'登錄就抽'}</Typography>
                    <CenterImage src={award06} />
                    <Typography variant="body2">{'價值 $2,350'}</Typography>
                    <span className={ common.center }>1名</span>
                </div>
                <div className={classes.awardDesc}>
                <Typography variant="body1" >{`【THERMOS】`}</Typography>
                <Typography variant="body1" >{`真空保溫瓶 1200ml`}</Typography>
                <Typography variant="body1" >{`IS212系列 (不銹鋼色)`}</Typography>
                </div>
            </div>


        </div>

	</div>);
};

export default InvoiceAwardSection;
